import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import VersionBadge from "../../ui/VersionBadge";

function PublicHeader() {
  return (
    <AppBar
      position="relative"
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "none",
        borderBottom: "1px solid #e0e0e0",
        overflow: "visible",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: { xs: 1.5, sm: 2 } }}>
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <img
            src="/logo192.png"
            alt="Drive Logo"
            style={{
              width: "28px",
              height: "28px",
              marginRight: "8px",
            }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: "#333333",
              fontWeight: 700,
              fontSize: { xs: "1.15rem", sm: "1.25rem" },
              letterSpacing: "-0.3px",
            }}
          >
            Drive
          </Typography>
          <VersionBadge sx={{ ml: 1 }} />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default PublicHeader;